import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postRejectWorkflow = createApi(`RejectWorkflowSlice`,"POST");

const RejectWorkflowSlice = createSlice({
  name: 'RejectWorkflowSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRejectWorkflow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRejectWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRejectWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RejectWorkflowSlice.reducer;